/* Teelted Scroll Pack : mouvement lié au scroll.
   Un seul moteur : chaque section [data-tl] reçoit une variable CSS --p (0 à 1), lissée,
   et les styles de tl-motion.css s'en servent. Rien ne bouge si l'utilisateur a demandé
   de réduire les animations. */
(function () {
  if (window.__tlMotion) return;
  window.__tlMotion = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var doc = document.documentElement;
  var vh = window.innerHeight, vw = window.innerWidth;
  var items = [], marquees = [], dirty = true, io = null;
  var lastY = window.scrollY, vel = 0;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  // position: sticky ne marche pas si un parent a overflow hidden/auto : on désactive alors l'épinglage
  function canSticky(el) {
    for (var p = el.parentElement; p && p !== doc; p = p.parentElement) {
      var cs = getComputedStyle(p);
      if (/(auto|scroll|hidden)/.test(cs.overflowX + ' ' + cs.overflowY)) return false;
    }
    return true;
  }

  function fillMarquee(m) {
    var g = m.track.querySelector('.tl-marq__group:not([data-clone])');
    if (!g) return;
    m.w = g.offsetWidth;
    var n = m.track.children.length;
    while (m.w && m.track.offsetWidth < vw + m.w && n < 12) {
      var c = g.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-clone', '');
      m.track.appendChild(c);
      n++;
    }
  }

  function layout() {
    vh = window.innerHeight; vw = window.innerWidth;
    items.forEach(function (it) {
      if (it.mode === 'rail') {
        var pin = it.el.hasAttribute('data-pin') && vw >= 900 && canSticky(it.el);
        it.el.classList.toggle('is-pin', pin);
        if (pin && it.track) {
          it.track.style.transform = 'none';
          it.dist = Math.max(0, it.track.scrollWidth - it.track.clientWidth) + 32;
          it.el.style.height = Math.round(it.dist + vh) + 'px';
        } else {
          it.el.style.height = '';
          it.dist = 0;
          if (it.track) it.track.style.transform = '';
        }
      }
    });
    marquees.forEach(fillMarquee);
    dirty = true;
  }

  function observeCards() {
    var cards = document.querySelectorAll('.tl-grid .tl-card:not([data-seen])');
    if (!('IntersectionObserver' in window)) {
      [].forEach.call(cards, function (c) { c.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
    }
    [].forEach.call(cards, function (c) {
      c.setAttribute('data-seen', '');
      var li = c.parentElement;
      var i = li && li.parentElement ? [].indexOf.call(li.parentElement.children, li) : 0;
      c.style.setProperty('--d', (i % 4) * 90 + 'ms');
      io.observe(c);
    });
  }

  function scan() {
    items = [].map.call(document.querySelectorAll('[data-tl]'), function (el) {
      var mode = el.getAttribute('data-tl');
      return {
        el: el, mode: mode,
        track: mode === 'rail' ? el.querySelector('.tl-rail__track') : null,
        cur: 0, target: 0, on: false, first: true, dist: 0
      };
    });
    marquees = [].map.call(document.querySelectorAll('.tl-marq'), function (el) {
      el.setAttribute('data-js', '');
      return {
        el: el, track: el.querySelector('.tl-marq__track'),
        dir: parseFloat(el.getAttribute('data-dir')) || 1,
        calm: el.hasAttribute('data-calm'), x: 0, w: 0
      };
    });
    observeCards();
    layout();
  }

  function measure() {
    items.forEach(function (it) {
      var r = it.el.getBoundingClientRect();
      it.on = r.bottom > -vh * 0.5 && r.top < vh * 1.5;
      var t;
      if (it.mode === 'hero') {
        t = -r.top / r.height;
      } else if (it.mode === 'rail' && it.el.classList.contains('is-pin')) {
        var span = r.height - vh;
        t = span > 1 ? -r.top / span : 0;
      } else if (it.mode === 'enter') {
        t = (vh - r.top) / r.height;
      } else {
        t = (vh - r.top) / (vh + r.height);
      }
      it.target = clamp(t, 0, 1);
    });
  }

  function frame() {
    var y = window.scrollY, dy = y - lastY;
    lastY = y;
    vel += (dy - vel) * 0.12;
    if (dy !== 0) dirty = true;
    if (dirty) { measure(); dirty = false; }

    items.forEach(function (it) {
      if (it.first) { it.cur = it.target; it.first = false; }
      else it.cur += (it.target - it.cur) * 0.14;
      if (Math.abs(it.target - it.cur) < 0.0004) it.cur = it.target;
      if (!it.on) return;
      it.el.style.setProperty('--p', it.cur.toFixed(4));
      if (it.track && it.dist) it.track.style.transform = 'translate3d(' + (-it.cur * it.dist).toFixed(1) + 'px,0,0)';
    });

    marquees.forEach(function (m) {
      if (!m.w || !m.track) return;
      var base = m.calm ? 0.35 : 0.9;
      var boost = m.calm ? 0 : vel * 0.45;
      m.x -= m.dir * (base + boost);
      if (m.x <= -m.w) m.x += m.w; else if (m.x > 0) m.x -= m.w;
      var skew = m.calm ? 0 : clamp(-vel * 0.18, -6, 6);
      m.track.style.transform = 'translate3d(' + m.x.toFixed(2) + 'px,0,0) skewX(' + skew.toFixed(2) + 'deg)';
    });

    window.requestAnimationFrame(frame);
  }

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(layout, 150); });
  window.addEventListener('load', layout);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(scan, 60); });
  });

  scan();
  doc.classList.add('tl-fx');
  window.requestAnimationFrame(frame);
})();